import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
})
export class ProgressBarComponent {
  @Input() type: string;
  @Input() timeConsumed: number;
  @Input() timeAvailable: number;
  @Input() size: string;
  @Input() overtime: number;

  constructor() {
    this.timeConsumed ? this.timeConsumed.toFixed() : 0;
    this.timeAvailable ? this.timeAvailable.toFixed() : 0;
  }
}
